import CancelGeneralConsentEmail from '@/views/Admin/Cancel/CancelGeneralConsentEmail'
import CancelGroupConsentEmail from '@/views/Admin/Cancel/CancelGroupConsentEmail'
import DashboardConsentDetail from '@/views/Admin/Dashboard/DashboardConsentDetail.vue'
import DataGeneralConsentDetail from '@/views/Admin/Dashboard/DataGeneralConsentDetail.vue'
import DataGroupConsentDetail from '@/views/Admin/Dashboard/DataGroupConsentDetail.vue'
import TemplteEmailAddNew from '@/views/Admin/Email/TemplateEmail/TemplteEmailAddNew.vue'
import SettingMenuIndex from '@/views/Admin/SettingMenu/SettingMenuIndex.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../components/layouts/Layout.vue'
import LayoutAPI from '../components/layouts/LayoutAPI.vue'
import LayoutEmail from '../components/layouts/LayoutEmail.vue'
import Login from '../components/pages/Login.vue'
import LoginShareToken from '../components/pages/LoginShareToken.vue'
import CheckRoleLevel from '../functions/CheckRoleLevel.js'
import store from '../store'
import ConfirmOneplatformAnnounce from '../views/Admin/Announce/OnePlatform/AnnounceConfirm.vue'
import HistoryOneplatformDetailAnnounce from '../views/Admin/Announce/OnePlatform/AnnounceDetail.vue'
import HistoryOneplatformAnnounce from '../views/Admin/Announce/OnePlatform/AnnounceHistory.vue'
import AnnounceOnePlatformIndex from '../views/Admin/Announce/OnePlatform/AnnounceIndex.vue'
import ConfirmAnnounce from '../views/Admin/Announce/Onechat/AnnounceConfirm.vue'
import HistoryDetailAnnounce from '../views/Admin/Announce/Onechat/AnnounceDetail.vue'
import HistoryAnnounce from '../views/Admin/Announce/Onechat/AnnounceHistory.vue'
import AnnounceIndex from '../views/Admin/Announce/Onechat/AnnounceIndex.vue'
import CancelGeneralConsent from '../views/Admin/Cancel/CancelGeneralConsent.vue'
import CancelGroupConsent from '../views/Admin/Cancel/CancelGroupConsent.vue'
import ConsentApprove from '../views/Admin/Consent/ConsentApprove.vue'
import ConsentCreate from '../views/Admin/Consent/ConsentCreate.vue'
import ConsentDetail from '../views/Admin/Consent/ConsentDetail.vue'
import ConsentUserDetail from '../views/Admin/Consent/ConsentDetailUser.vue'
import ConsentEdit from '../views/Admin/Consent/ConsentEdit.vue'
import EmailGeneralConsent from '../views/Admin/Consent/ConsentEmail/EmailGeneralConsent.vue'
import EmailGroupConsent from '../views/Admin/Consent/ConsentEmail/EmailGroupConsent.vue'
import ImportEmail from '../views/Admin/Consent/ConsentEmail/ImportEmail.vue'
import PetitionEmail from '../views/Admin/Consent/ConsentEmail/PetitionEmail.vue'
import ConsentIndex from '../views/Admin/Consent/ConsentIndex.vue'
import ConsentCreateOnechatCreate from '../views/Admin/Consent/ConsentOnechat/ConsentOnechatCreate.vue'
import OnechatConsentHistory from '../views/Admin/Consent/ConsentOnechat/HistoryOnechat/ConsentOnechatIndex.vue'
import OnechatGeneralConsentDetailHistory from '../views/Admin/Consent/ConsentOnechat/HistoryOnechat/GeneralConsentDetail.vue'
import OnechatGroupConsentDetailHistory from '../views/Admin/Consent/ConsentOnechat/HistoryOnechat/GroupConsentDetail.vue'
import OnechatGeneralConsent from '../views/Admin/Consent/ConsentOnechat/OnechatGeneralConsent.vue'
import OnechatGroupConsent from '../views/Admin/Consent/ConsentOnechat/OnechatGroupConsent.vue'
import ConsentCreateOnePlatformCreate from '../views/Admin/Consent/OnePlatform/ConsentOnePlatformCreate.vue'
import OneplatformOneplatformConsentHistory from '../views/Admin/Consent/OnePlatform/HistoryOnePlatform/ConsentOnePlatformIndex.vue'
import OneplatformGeneralConsentDetailHistory from '../views/Admin/Consent/OnePlatform/HistoryOnePlatform/GeneralConsentDetail.vue'
import OneplatformGroupConsentDetailHistory from '../views/Admin/Consent/OnePlatform/HistoryOnePlatform/GroupConsentDetail.vue'
import OneplatformGeneralConsent from '../views/Admin/Consent/OnePlatform/OnePlatformGeneralConsent.vue'
import OneplatformGroupConsent from '../views/Admin/Consent/OnePlatform/OnePlatformGroupConsent.vue'
import ConsentGroupCreate from '../views/Admin/ConsentGroup/ConsentGroupCreate.vue'
import ConsentGroupDetail from '../views/Admin/ConsentGroup/ConsentGroupDetail.vue'
import ConsentGroupEdit from '../views/Admin/ConsentGroup/ConsentGroupEdit.vue'
import ConsentGroupIndex from '../views/Admin/ConsentGroup/ConsentGroupIndex.vue'
import ConsentGroupUpdate from '../views/Admin/ConsentGroup/ConsentGroupUpdate.vue'
import GroupConsentApprove from '../views/Admin/ConsentGroup/GroupConsentApprove.vue'
import SMSIndex from '../views/Admin/ConsentSMS/SMSIndex.vue'
import CookiesAdd from '../views/Admin/Cookies/CookiesAdd.vue'
import CookiesDetail from '../views/Admin/Cookies/CookiesDetail.vue'
import CookiesIndex from '../views/Admin/Cookies/CookiesIndex.vue'
import CookiesTestWebscript from '../views/Admin/Cookies/CookiesTestWebscript.vue'
import CookiesUpdate from '../views/Admin/Cookies/CookiesUpdate.vue'
import Dashboard from '../views/Admin/Dashboard/DashboardIndex.vue'
import DashboardUserIndex from '../views/Admin/Dashboard/DashboardUserIndex.vue'
import DetailConsent from '../views/Admin/Dashboard/DetailConsent.vue'
import GetConsentDetailDashbord from '../views/Admin/Dashboard/GetConsentDetailDashbord.vue'
import SmtpEmailAdd from '../views/Admin/Email/SMTPEmail/SMTPEmailAdd.vue'
import SmtpEmailIndex from '../views/Admin/Email/SMTPEmail/SMTPEmailIndex.vue'
import SmtpEmailUpdate from '../views/Admin/Email/SMTPEmail/SMTPEmailUpdate.vue'
import TemplateEmailDetail from '../views/Admin/Email/TemplateEmail/TemplateEmailDetail.vue'
import TemplateEmailIndex from '../views/Admin/Email/TemplateEmail/TemplateEmailIndex.vue'
import TemplateEmailUpdate from '../views/Admin/Email/TemplateEmail/TemplateEmailUpdate.vue'
import TemplateEmailAdd from '../views/Admin/Email/TemplateEmail/TemplteEmailAdd.vue'
import PetitionData from '../views/Admin/Petition/PetitionIndex.vue'
import PolicyApprove from '../views/Admin/Policy/PolicyApprove.vue'
import PolicyCreate from '../views/Admin/Policy/PolicyCreate.vue'
import PolicyDetail from '../views/Admin/Policy/PolicyDetail.vue'
import PolicyEdit from '../views/Admin/Policy/PolicyEdit.vue'
import PolicyIndex from '../views/Admin/Policy/PolicyIndex.vue'
import ConfigLogo from '../views/Admin/Profile/ConfigLogo.vue'
import Profile from '../views/Admin/Profile/ProfileIndex.vue'
import DocumentAPI from '../views/Admin/ProfileAPI/DocumentAPI.vue'
import DocumentAPIGetDetail from '../views/Admin/ProfileAPI/DocumentAPIGetDetail.vue'
import DocumentAPIWebscript from '../views/Admin/ProfileAPI/DocumentAPIWebscript.vue'
import ProfileAPIIndex from '../views/Admin/ProfileAPI/ProfileAPIIndex.vue'
import QrcodeAdd from '../views/Admin/Qrcode/QrcodeAdd.vue'
import QrcodeDetail from '../views/Admin/Qrcode/QrcodeDetail.vue'
import QrcodeIndex from '../views/Admin/Qrcode/QrcodeIndex.vue'
import QrcodeUpdate from '../views/Admin/Qrcode/QrcodeUpdate.vue'
import QRcodeConsent from '../views/Admin/Qrcode/QrcodeConsent.vue'
import SearchConsentDetail from '../views/Admin/SearchConsent/SearchConsentDetail.vue'
import SearchConsent from '../views/Admin/SearchConsent/SearchConsentListIndex.vue'
import UploadIndex from '../views/Admin/UploadDocument/UploadIndex.vue'
import ConsentListEmail from '../views/Email/ConsentList/ConsentListIndex.vue'
import Error404 from '../views/LandingPage404.vue'
import AnnounceList from '../views/User/AnnounceList/AnnounceListIndex.vue'
import ConsentList from '../views/User/ConsentList/ConsentListIndex.vue'
import GeneralConsent from '../views/User/ConsentList/GeneralConsentDetail.vue'
import GroupConsent from '../views/User/ConsentList/GroupConsentDetail.vue'
import PetitionDetail from '../views/User/Petition/PetitionDetail.vue'
import OneplatformExtrnalConsent from '../views/Admin/Consent/OnePlatform/OneplatformExtrnalConsent.vue'
import BotOnePlatformIndex from '../views/Admin/BotOnePlatform/BotOnePlatformIndex.vue'
import BotOnePlatformDetail from '../views/Admin/BotOnePlatform/BotOnePlatformDetail.vue'
import SettingBot from '../views/Admin/BotOnePlatform/Setting/SettingBot.vue'
import CreateBot from '../views/Admin/BotOnePlatform/Setting/CreateBot.vue'
import UpdateBot from '../views/Admin/BotOnePlatform/Setting/UpdateBot.vue'
import TemplateIndex from '../views/Admin/BotOnePlatform/Template/TemplateIndex.vue'
import TemplateAdd from '../views/Admin/BotOnePlatform/Template/TemplateAdd.vue'
import TemplateEdit from '../views/Admin/BotOnePlatform/Template/TemplateEdit.vue'
import BotOnePlatformAdd from '../views/Admin/BotOnePlatform/BotOnePlatformAdd.vue'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.use(VueRouter)

const AuthenticatedSignout = async (to, from, next) => {
  if (store.getters.Authen === true || Vue.$cookies.get('RoleAccount')) {
    store
      .dispatch('AUTH_PORTAL_EXPIRED')
      .then(
        Vue.$cookies.remove('OneUsername'),
        Vue.$cookies.remove('OneAccountId'),
        Vue.$cookies.remove('OneAccessToken'),
        Vue.$cookies.remove('OneRefreshToken'),
        Vue.$cookies.remove('Timestamps'),
        Vue.$cookies.remove('RoleAccount'),
        Vue.$cookies.remove('BusinessSelect'),
        Vue.$cookies.remove('TaxIdCMP'),
        localStorage.removeItem('BusinessNameTH'),
        localStorage.removeItem('BusinessNameEng'),
        localStorage.removeItem('TaxId'),
        localStorage.removeItem('BusinessId'),
        localStorage.removeItem('lang'),
        next('/')
      )
      .catch((error) => {
        console.log(error.response)
      })
  } else {
    store.dispatch('AUTH_PORTAL_EXPIRED')
    Vue.$cookies.remove('OneUsername'),
    Vue.$cookies.remove('OneAccountId'),
    Vue.$cookies.remove('OneAccessToken'),
    Vue.$cookies.remove('OneRefreshToken'),
    Vue.$cookies.remove('Timestamps'),
    Vue.$cookies.remove('RoleAccount'),
    Vue.$cookies.remove('BusinessSelect'),
    Vue.$cookies.remove('TaxIdCMP'),
    localStorage.removeItem('BusinessNameTH'),
    localStorage.removeItem('BusinessNameEng'),
    localStorage.removeItem('TaxId'),
    localStorage.removeItem('BusinessId'),
    localStorage.removeItem('lang')
  }
  next('/')
}

const AuthenticatedChecker = async (to, from, next) => {
  const AccessRole = await CheckRoleLevel.CheckRoleAccess(to)

  if (store.getters.Authen === true) {
    // ตัวแปร store.getters.ชื่อตัวเเปรgetters ของ authorize
    const ActiveRole = CheckRoleLevel.CheckRoleActiveMenu(
      store.getters.DataCheckRole
    )
    if (AccessRole.includes(ActiveRole) === true) {
      // store.dispatch('SET_LOADING_LOGIN', false)
      next('/profile')
    } else {
      next()
    }
  } else {
    store.dispatch('AUTH_PORTAL_CHECK').then((response) => {
      if (response.Status === 'OK') {
        // const ActiveRole = CheckRoleLevel.CheckRoleActiveMenu(
        //   store.getters.DataCheckRole
        // )
        // if (AccessRole.includes(ActiveRole) === true) {
        //   // store.dispatch('SET_LOADING_LOGIN', false)
        //   next('/')
        // } else {
        //   next()
        // }
        next()
      } else {
        next('/logout')
      }
    })
  }
}
const routes = [
  {
    path: '*',
    name: 'wildcard',
    redirect: '/Notfound'
  },
  {
    path: '/Notfound',
    name: 'Error404',
    component: Error404
  },
  {
    path: '/',
    name: 'Login',
    // redirect: '/login',
    component: Login
  },
  {
    path: '/login-share',
    name: 'LoginShareToken',
    component: LoginShareToken
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: 'เข้าสู่ระบบ | CMP' }
  },
  {
    path: '/email-general-consent/:param',
    name: 'EmailGeneralConsent',
    component: EmailGeneralConsent,
    meta: { title: 'ความยินยอม Email แบบทั่วไป | CMP' }
  },
  {
    path: '/email-group-consent/:param',
    name: 'EmailGroupConsent',
    component: EmailGroupConsent,
    meta: { title: 'ความยินยอม Email แบบกลุ่ม | CMP' }
  },
  {
    path: '/onechat-general-consent/:param/:param',
    name: 'OnechatGeneralConsent',
    component: OnechatGeneralConsent,
    meta: { title: 'ความยินยอม Onechat แบบทั่วไป | CMP' }
  },
  {
    path: '/onechat-group-consent/:param/:param',
    name: 'OnechatGroupConsent',
    component: OnechatGroupConsent,
    meta: { title: 'ความยินยอม Onechat แบบกลุ่ม | CMP' }
  },
  {
    path: '/onechat-history/:param/:param/:param',
    name: 'OnechatConsentHistory',
    component: OnechatConsentHistory,
    meta: { title: 'ประวัติความยินยอม | CMP' }
  },
  {
    path: '/onechat-general-history',
    name: 'OnechatGeneralConsentDetailHistory',
    component: OnechatGeneralConsentDetailHistory,
    meta: { title: 'รายละเอียดความยินยอมแบบทั่วไป | CMP' }
  },
  {
    path: '/cancel-general-consent/:param/:param',
    name: 'CancelGeneralConsent',
    component: CancelGeneralConsent,
    meta: { title: 'ยกเลิก แบบทั่วไป | CMP' }
  },
  {
    path: '/cancel-group-consent/:param/:param',
    name: 'CancelGroupConsent',
    component: CancelGroupConsent,
    meta: { title: 'ยกเลิก แบบกลุ่ม | CMP' }
  },
  {
    path: '/onechat-group-history',
    name: 'OnechatGroupConsentDetailHistory',
    component: OnechatGroupConsentDetailHistory,
    meta: { title: 'รายละเอียดความยินยอมแบบกลุ่ม | CMP' }
  },
  {
    path: '/onechat-announce-acknowledge/:param/:param',
    name: 'ConfirmAnnounce',
    component: ConfirmAnnounce,
    meta: { title: 'รับทราบประกาศ | CMP' }
  },
  {
    path: '/onechat-announce-history/:param/:param',
    name: 'HistoryAnnounce',
    component: HistoryAnnounce,
    meta: { title: 'ประวัติรายการประกาศ | CMP' }
  },
  {
    path: '/onechat-announce-history-detail',
    name: 'HistoryDetailAnnounce',
    component: HistoryDetailAnnounce,
    meta: { title: 'รายละเอียดประวัติรายการประกาศ | CMP' }
  },
  {
    path: '/oneplatform-general-history',
    name: 'OneplatformGeneralConsentDetailHistory',
    component: OneplatformGeneralConsentDetailHistory,
    meta: { title: 'รายละเอียดความยินยอมแบบทั่วไป | CMP' }
  },
  {
    path: '/oneplatform-group-history',
    name: 'OneplatformGroupConsentDetailHistory',
    component: OneplatformGroupConsentDetailHistory,
    meta: { title: 'รายละเอียดความยินยอมแบบกลุ่ม | CMP' }
  },
  {
    path: '/oneplatform-announce-acknowledge/:param/:param',
    name: 'ConfirmOneplatformAnnounce',
    component: ConfirmOneplatformAnnounce,
    meta: { title: 'รับทราบประกาศ Oneplatform | CMP' }
  },
  {
    path: '/oneplatform-announce-history/:param/:param',
    name: 'HistoryOneplatformAnnounce',
    component: HistoryOneplatformAnnounce,
    meta: { title: 'ประวัติรายการประกาศ Oneplatform | CMP' }
  },
  {
    path: '/oneplatform-announce-history-detail',
    name: 'HistoryOneplatformDetailAnnounce',
    component: HistoryOneplatformDetailAnnounce,
    meta: { title: 'รายละเอียดประวัติรายการประกาศ Oneplatform | CMP' }
  },
  {
    path: '/oneplatform-history/:param/:param/:param',
    name: 'OneplatformOneplatformConsentHistory',
    component: OneplatformOneplatformConsentHistory,
    meta: { title: 'ประวัติความยินยอม | CMP' }
  },
  {
    path: '/oneplatform-general-consent/:param/:param',
    name: 'OneplatformGeneralConsent',
    component: OneplatformGeneralConsent,
    meta: { title: 'ความยินยอม Oneplatform แบบทั่วไป | CMP' }
  },
  {
    path: '/oneplatform-group-consent/:param/:param',
    name: 'OneplatformGroupConsent',
    component: OneplatformGroupConsent,
    meta: { title: 'ความยินยอม Oneplatform แบบกลุ่ม | CMP' }
  },
  {
    path: '/cancel-general-consent-email/:param/:param',
    name: 'CancelGeneralConsentEmail',
    component: CancelGeneralConsentEmail,
    meta: { title: 'ยื่นคำร้องผ่าน Email | CMP' }
  },
  {
    path: '/cancel-group-consent-email/:param/:param',
    name: 'CancelGroupConsentEmail',
    component: CancelGroupConsentEmail,
    meta: { title: 'ยื่นคำร้องผ่าน Email | CMP' }
  },
  {
    path: '/petition-email/:param/:param',
    name: 'PetitionEmail',
    component: PetitionEmail,
    meta: { title: 'ยื่นคำร้องผ่าน Email | CMP' }
  },
  {
    path: '/policy-approve/:param/:param/:param',
    name: 'PolicyApprove',
    component: PolicyApprove,
    meta: { title: 'ยืนยันนโยบาย | CMP' }
  },
  {
    path: '/consent-approve/:param/:param/:param',
    name: 'ConsentApprove',
    component: ConsentApprove,
    meta: { title: 'ยืนยันความยินยอม | CMP' }
  },
  {
    path: '/group-consent-approve/:param/:param/:param',
    name: 'GroupConsentApprove',
    component: GroupConsentApprove,
    meta: { title: 'ยืนยันกลุ่มความยินยอม | CMP' }
  },
  {
    path: '/consent/qrcode/:param',
    name: 'QRcodeConsent',
    component: QRcodeConsent,
    meta: { title: 'ยืนยัน QR code | CMP' }
  },
  {
    path: '/test-webscript',
    name: 'CookiesTestWebscript',
    component: CookiesTestWebscript,
    meta: { title: 'Webscript | CMP' }
  },
  {
    path: '/',
    name: 'LayoutAPI',
    component: LayoutAPI,
    // beforeEnter: AuthenticatedChecker,
    children: [
      {
        path: '/document-service-index',
        name: 'ProfileAPIIndex',
        component: ProfileAPIIndex,
        meta: { title: 'เอกสารAPI | CMP' }
      },
      {
        path: '/document-service-2',
        name: 'DocumentAPI',
        component: DocumentAPI,
        meta: { title: 'เอกสารAPI | CMP' }
      },
      {
        path: '/document-service-3',
        name: 'DocumentAPIGetDetail',
        component: DocumentAPIGetDetail,
        meta: { title: 'เอกสารAPI | CMP' }
      },
      {
        path: '/document-service-webscript',
        name: 'DocumentAPIWebscript',
        component: DocumentAPIWebscript,
        meta: { title: 'เอกสารAPI | CMP' }
      }
    ]
  },
  {
    path: '/',
    name: 'LayoutEmail',
    component: LayoutEmail,
    // beforeEnter: AuthenticatedChecker,
    children: [
      {
        path: '/consent-list-email',
        name: 'ConsentListEmail',
        component: ConsentListEmail,
        meta: { title: 'รายการความยินยอมอีเมล | CMP' }
      }
    ]
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    beforeEnter: AuthenticatedChecker,
    children: [
      {
        path: '/dashboard',
        name: 'ข้อมูลการใช้งาน',
        component: Dashboard,
        meta: { title: 'ข้อมูลการใช้งาน | CMP' }
      },
      {
        path: '/search-consent-detail',
        name: 'SearchConsentDetail',
        component: SearchConsentDetail,
        meta: { title: 'รายละเอียดรายการที่ส่งทั่วไป | CMP' }
      },
      {
        path: '/consent-dashboard-detail',
        name: 'DashboardConsentDetail',
        component: DashboardConsentDetail,
        meta: { title: 'รายละเอียดความยินยอม | CMP' }
      },
      {
        path: '/consent-detail-dashboard',
        name: 'GetConsentDetailDashbord',
        component: GetConsentDetailDashbord,
        meta: { title: 'รายละเอียดความยินยอม | CMP' }
      },
      {
        path: '/consent-dashboard',
        name: 'DetailConsent',
        component: DetailConsent,
        meta: { title: 'รายละเอียดความยินยอม | CMP' }
      },
      {
        path: '/data-general-detail',
        name: 'DataGeneralConsentDetail',
        component: DataGeneralConsentDetail,
        meta: { title: 'รายละเอียดความยินยอมทั่วไป | CMP' }
      },
      {
        path: '/data-group-detail',
        name: 'DataGroupConsentDetail',
        component: DataGroupConsentDetail,
        meta: { title: 'รายละเอียดความยินยอมแบบกลุ่ม | CMP' }
      },
      {
        path: '/profile',
        name: 'ตรวจสอบสิทธิตนเอง',
        component: Profile,
        meta: { title: 'ข้อมูลผู้ใช้งาน | CMP' }
      },
      {
        path: '/settings',
        name: 'SettingMenuIndex',
        component: SettingMenuIndex,
        meta: { title: 'ตั้งค่าสิทธิ์เมนู | CMP' }
      },
      {
        path: '/policy-index',
        name: 'PolicyIndex',
        component: PolicyIndex,
        meta: { title: 'สร้างนโยบาย | CMP' }
      },
      {
        path: '/policy-create',
        name: 'PolicyCreate',
        component: PolicyCreate,
        meta: { title: 'สร้างนโยบาย | CMP' }
      },
      {
        path: '/policy-detail',
        name: 'PolicyDetail',
        component: PolicyDetail,
        meta: { title: 'รายละเอียดนโยบาย | CMP' }
      },
      {
        path: '/policy-edit',
        name: 'PolicyEdit',
        component: PolicyEdit,
        meta: { title: 'แก้ไขนโยบาย | CMP' }
      },
      {
        path: '/consent-index',
        name: 'ความยินยอม',
        component: ConsentIndex,
        meta: { title: 'สร้างความยินยอม | CMP' }
      },
      {
        path: '/consent-create',
        name: 'ConsentCreate',
        component: ConsentCreate,
        meta: { title: 'สร้างความยินยอม | CMP' }
      },
      {
        path: '/consent-create-onechat',
        name: 'ConsentCreateOnechatCreate',
        component: ConsentCreateOnechatCreate,
        meta: { title: 'ขอความยินยอม Onechat | CMP' }
      },
      {
        path: '/consent-create-oneplatform',
        name: 'OnePlatform',
        component: ConsentCreateOnePlatformCreate,
        meta: { title: 'ขอความยินยอม OnePlatform | CMP' }
      },
      {
        path: '/consent-detail',
        name: 'ConsentDetail',
        component: ConsentDetail,
        meta: { title: 'รายละเอียดเอกสารความยินยอม | CMP' }
      },
      {
        path: '/consent-edit',
        name: 'ConsentEdit',
        component: ConsentEdit,
        meta: { title: 'แก้ไขเอกสารความยินยอม | CMP' }
      },
      {
        path: '/email-smtp-index',
        name: 'ตั้งค่า SMTP อีเมล',
        component: SmtpEmailIndex,
        meta: { title: 'ตั้งค่า SMTP Email | CMP' }
      },
      {
        path: '/email-smtp-add',
        name: 'SmtpEmailAdd',
        component: SmtpEmailAdd,
        meta: { title: 'เปิดใช้งาน SMTP | CMP' }
      },
      {
        path: '/email-smtp-update',
        name: 'SmtpEmailUpdate',
        component: SmtpEmailUpdate,
        meta: { title: 'แก้ไขข้อมูล SMTP | CMP' }
      },
      {
        path: '/email-template-index',
        name: 'ตั้งค่า Template อีเมล',
        component: TemplateEmailIndex,
        meta: { title: 'ตั้งค่า Template Email | CMP' }
      },
      {
        path: '/email-template-add',
        name: 'TemplateEmailAdd',
        component: TemplateEmailAdd,
        meta: { title: 'เพิ่ม Template Email | CMP' }
      },
      {
        path: '/email-template-add-new',
        name: 'TemplteEmailAddNew',
        component: TemplteEmailAddNew,
        meta: { title: 'เพิ่ม Template Email | CMP' }
      },
      {
        path: '/email-template-update',
        name: 'TemplateEmailUpdate',
        component: TemplateEmailUpdate,
        meta: { title: 'แก้ไข Template Email | CMP' }
      },
      {
        path: '/email-template-Detail',
        name: 'TemplateEmailDetail',
        component: TemplateEmailDetail,
        meta: { title: 'รายละเอียด Template Email | CMP' }
      },
      {
        path: '/consent-management-group-index',
        name: 'ConsentGroupIndex',
        component: ConsentGroupIndex,
        meta: { title: 'จัดการกลุ่มความยินยอม | CMP' }
      },
      {
        path: '/consent-management-group-add',
        name: 'ConsentGroupCreate',
        component: ConsentGroupCreate,
        meta: { title: 'เพิ่มกลุ่มความยินยอม | CMP' }
      },
      {
        path: '/consent-management-group-update',
        name: 'ConsentGroupUpdate',
        component: ConsentGroupUpdate,
        meta: { title: 'แก้ไขกลุ่มความยินยอม | CMP' }
      },
      {
        path: '/consent-management-group-detail',
        name: 'ConsentGroupDetail',
        component: ConsentGroupDetail,
        meta: { title: 'รายละเอียดกลุ่มความยินยอม | CMP' }
      },
      {
        path: '/consent-management-group-edit',
        name: 'ConsentGroupEdit',
        component: ConsentGroupEdit,
        meta: { title: 'แก้ไขรายละเอียดกลุ่มความยินยอม | CMP' }
      },
      {
        path: '/dashboard-user',
        name: 'ภาพรวมการใช้งาน',
        component: DashboardUserIndex,
        meta: { title: 'ข้อมูลการใช้งาน | CMP' }
      },

      {
        path: '/consent-list',
        name: 'รายการความยินยอม',
        component: ConsentList,
        meta: { title: 'รายการความยินยอม | CMP' }
      },
      {
        path: '/announce-list',
        name: 'รายการประกาศ',
        component: AnnounceList,
        meta: { title: 'รายการประกาศ | CMP' }
      },
      {
        path: '/petition-index',
        name: 'คำร้องที่ถูกส่งถึง',
        component: PetitionData,
        meta: { title: 'ข้อมูลคำร้อง | CMP' }
      },
      {
        path: '/search-consent-index',
        name: 'ค้นหาความยินยอม',
        component: SearchConsent,
        meta: { title: 'ค้นหาความยินยอม | CMP' }
      },
      {
        path: '/petition-detail',
        name: 'PetitionDetail',
        component: PetitionDetail,
        meta: { title: 'รายละเอียดข้อมูลคำร้อง | CMP' }
      },
      {
        path: '/general-consent-detail',
        name: 'GeneralConsent',
        component: GeneralConsent,
        meta: { title: 'รายละเอียดความยินยอมทั่วไป | CMP' }
      },
      {
        path: '/group-consent-detail',
        name: 'GroupConsent',
        component: GroupConsent,
        meta: { title: 'รายละเอียดความยินยอมแบบกลุ่ม | CMP' }
      },
      {
        path: '/consent-detail-user',
        name: 'ConsentUserDetail',
        component: ConsentUserDetail,
        meta: { title: 'รายละเอียดความยินยอม | CMP' }
      },
      {
        path: '/upload-email',
        name: 'Email',
        component: ImportEmail,
        meta: { title: 'อัปโหลด อีเมล | CMP' }
      },
      {
        path: '/cookies-index',
        name: 'Cookies',
        component: CookiesIndex,
        meta: { title: 'คุกกี้ | CMP' }
      },
      {
        path: '/qrcode-index',
        name: 'Qrcode',
        component: QrcodeIndex,
        meta: { title: 'Qrcode | CMP' }
      },
      {
        path: '/qrcode-add',
        name: 'Qrcode',
        component: QrcodeAdd,
        meta: { title: 'เพิ่มข้อมูล Qrcode | CMP' }
      },
      {
        path: '/qrcode-update',
        name: 'Qrcode',
        component: QrcodeUpdate,
        meta: { title: 'แก้ไขข้อมูล Qrcode | CMP' }
      },
      {
        path: '/qrcode-detail',
        name: 'Qrcode',
        component: QrcodeDetail,
        meta: { title: 'รายละเอียด Qrcode | CMP' }
      },
      {
        path: '/cookies-add',
        name: 'CookiesAdd',
        component: CookiesAdd,
        meta: { title: 'ลงทะเบียนผู้ใช้ระบบ | CMP' }
      },
      {
        path: '/cookies-update',
        name: 'CookiesUpdate',
        component: CookiesUpdate,
        meta: { title: 'แก้ไขผู้ใช้ระบบ | CMP' }
      },
      {
        path: '/cookies-detail',
        name: 'CookiesDetail',
        component: CookiesDetail,
        meta: { title: 'รายละเอียดผู้ใช้ระบบ | CMP' }
      },
      {
        path: '/sms-index',
        name: 'SMSIndex',
        component: SMSIndex,
        meta: { title: 'SMS | CMP' }
      },
      {
        path: '/upload-index',
        name: 'Upload',
        component: UploadIndex,
        meta: { title: 'อัปโหลดเอกสาร | CMP' }
      },
      // {
      //   path: '/announce-index',
      //   name: 'AnnounceIndex',
      //   component: AnnounceIndex,
      //   meta: { title: 'ประกาศ Onechat | CMP' }
      // },
      {
        path: '/announce-oneplatform-index',
        name: 'OnePlatform',
        component: AnnounceOnePlatformIndex,
        meta: { title: 'ประกาศ OnePlatform | CMP' }
      },
      {
        path: '/config-logo',
        name: 'ConfigLogo',
        component: ConfigLogo,
        meta: { title: 'ตั้งค่าโลโก้ | CMP' }
      },
      {
        path: '/bot-index',
        name: 'BotOnePlatformIndex',
        component: BotOnePlatformIndex,
        meta: { title: 'Bot Oneplatform | CMP' }
      },
      {
        path: '/bot-add',
        name: 'BotOnePlatformAdd',
        component: BotOnePlatformAdd,
        meta: { title: 'สร้าง Bot Oneplatform | CMP' }
      },
      {
        path: '/bot-detail',
        name: 'BotOnePlatformDetail',
        component: BotOnePlatformDetail,
        meta: { title: 'รายละเอียด Bot Oneplatform | CMP' }
      },
      {
        path: '/config-bot',
        name: 'SettingBotOnePlatform',
        component: SettingBot,
        meta: { title: 'ตั้งค่า Bot Oneplatform | CMP' }
      },
      {
        path: '/config-bot-add',
        name: 'AddBotOnePlatform',
        component: CreateBot,
        meta: { title: 'เพิ่ม Bot Oneplatform | CMP' }
      },
      {
        path: '/config-bot-update',
        name: 'UpdateBotOnePlatform',
        component: UpdateBot,
        meta: { title: 'แก้ไข Bot Oneplatform | CMP' }
      },
      {
        path: '/template-bot',
        name: 'TemplateBot',
        component: TemplateIndex,
        meta: { title: 'Template Bot | CMP' }
      },
      {
        path: '/template-bot-add',
        name: 'AddTemplateBot',
        component: TemplateAdd,
        meta: { title: 'เพิ่ม Template Bot | CMP' }
      },
      {
        path: '/template-bot-update',
        name: 'UpdateTemplateBot',
        component: TemplateEdit,
        meta: { title: 'แก้ไข Template Bot | CMP' }
      },
      
    ]
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: AuthenticatedSignout
  },
  {
    path: '/oneplatform-external-consent/:param/:param',
    name: 'OneplatformExtrnalConsent',
    component: OneplatformExtrnalConsent,
    meta: { title: 'ความยินยอม Oneplatform | CMP' }
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  routes
})

const DEFAULT_TITLE = 'Consent Management Platform (CMP)'
router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE
  })
})
export default router
